/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import * as RoleServices from '~/services/Role';
import { ResourcesProvider } from '~/components/Provider';

/**
 * Exports
*/

export const RoleContext = React.createContext({});

/**
 * 
 */
export function RoleProvider(props) {
  return (
    <ResourcesProvider name='Role' context={ RoleContext } services={ RoleServices }>
      { props.children }
    </ResourcesProvider>
  );
}